//const PHONE_REGEX = '^(0|\\+33)[1-9][0-9]{8}$'; français
const PHONE_REGEX = '^[0-9]{2} [0-9]{2} [0-9]{2} [0-9]{2} [0-9]{2}$';
const PHONE_REGEX_2 = '^[0-9]{10}$';
export default ({app}, inject) => {
  inject('generateOptions', (list,attribut="nom") => {
    //let options = [{ value: 0, text: 'Sélectionner tout', item:'' }];
    let options = [];
    list.forEach((elem, index) => {
      if((options.filter(unit=>unit.text===elem[attribut])).length===0)
        if(elem[attribut])
            options.push({value: index, text: elem[attribut], item: elem})
    });
    return options;
  }),
    inject('isLatitude', (lat) => {
      return isFinite(lat) && Math.abs(lat) <= 90 && !!lat;
    }),
    inject('validMail', (email) => {
      if(typeof email === "undefined") return false;
      if(!email && email.toString() === '') return true;

      return /[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,3}/.test(email);
    }),
    inject('isLongitude', (lng) => {
      return isFinite(lng) && Math.abs(lng) <= 180 && !!lng;
    }),
    inject('isValidNom', (nom = '') => {
      return nom.length>1;
    }),
    inject('isPhone', (phone) => {
      return phone==='' || ((new RegExp(PHONE_REGEX)).test(phone)) || ((new RegExp(PHONE_REGEX_2)).test(phone));
    }),
    inject('isOptionEdition', (event) => {
      const className = event.target.classList.value;
      return !(className.includes('option-edition') || className.includes('icon-elipsis-h'));
    })
}
